import React, { useEffect } from 'react';
import { Hero } from './components/sections/Hero';
import { StatsBar } from './components/sections/StatsBar';
import { HeroTestimonials } from './components/sections/HeroTestimonials';
import { Problems } from './components/sections/Problems';
import { ProductShowcase } from './components/sections/ProductShowcase';
import { Chapters } from './components/sections/Chapters';
import { Bonuses } from './components/sections/Bonuses';
import { UrgencyBanner } from './components/sections/UrgencyBanner';
import { Offer } from './components/sections/Offer';
import { TestimonialsGrid } from './components/sections/TestimonialsGrid';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { Comparison } from './components/sections/Comparison';
import { FinalCta } from './components/sections/FinalCta';
import { SiteFooter } from './components/sections/SiteFooter';
export function App() {
  useEffect(() => {
    document.title = 'El Método del Padre del Futbolista – Método Fútbol Digital';

    // Meta Domain Verification
    if (!document.querySelector('meta[name="facebook-domain-verification"]')) {
      const meta = document.createElement('meta');
      meta.name = 'facebook-domain-verification';
      meta.content = '9wfqwcalw402d9p954kaixicq4nv5s';
      document.head.appendChild(meta);
    }

    // Meta Pixel Code
    const win = window as any;
    if (!win.fbq) {
      ;
      (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          b.head.appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      win.fbq('init', '2564757130633111');
      win.fbq('track', 'PageView');
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=2564757130633111&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    }
  }, []);
  return <div className="w-full bg-ink-950 font-sans text-body" data-id="element-0" data-mp="3qb7i9azor2f7">
      <Hero data-id="element-1" data-mp="3qcqyj1lcddgz" />
      <main data-id="element-2" data-mp="3qcipxlw94ubl">
        <StatsBar data-id="element-3" data-mp="3qd0t72hc08t0" />
        <HeroTestimonials data-id="element-4" data-mp="3lkr41oo1jcrs" />
        <Problems data-id="element-5" data-mp="3ljg11r2f691q" />
        <ProductShowcase data-id="element-6" data-mp="3liwlgh08rwqv" />
        <Chapters data-id="element-7" data-mp="3limsckjwh9gy" />
        <Bonuses data-id="element-8" data-mp="2xun4bsdz3x62" />
        <UrgencyBanner data-id="element-9" data-mp="2xu3i3zhaimm8" />
        <Offer data-id="element-10" data-mp="2xtbzdp8skjdd" />
        <TestimonialsGrid data-id="element-11" data-mp="2xt24pocsxo1c" />
        <Guarantee data-id="element-12" data-mp="2svtnbpzh9o15" />
        <Faq data-id="element-13" data-mp="2swbq75gnb0i1" />
        <Comparison data-id="element-14" data-mp="2suqzxs1d63pz" />
        <FinalCta data-id="element-15" data-mp="2svadyxnw87yq" />
      </main>
      <SiteFooter data-id="element-16" data-mp="18drjdvxkvfdt" />
    </div>;
}